import React, { useEffect, useState } from "react";
import { eventAttendeeData } from "../../../../constants/EventAttendeeData";
import { useParams } from "react-router-dom";
import httpServices from "../../../../services/httpServices";
import AddTicketScanner from "./ticketScanner";
import { toast } from "react-toastify";

const SingleEventScanner = () => {
  const { title, id } = useParams();
  const [addMoreScanner, setAddMoreScanner] = useState(false);
  const [sannerList, setSannerList] = useState([]);
  const [editData, setEditData] = useState();
  const [isEditScanner, setIsEditScanner] = useState(false);

  const getEventScanner = async () => {
    try {
      const { response, error } = await httpServices.get(
        `/scannersDetails/list/byEventId/${id}`,
        {
          skip: !id,
        }
      );

      if (error) {
        throw error;
      }
      if (response.status === 200) {
        setSannerList(response.data?.data);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };
  useEffect(() => {
    getEventScanner();
  }, [id]);

  const toggleAddMoreScanner = () => {
    setAddMoreScanner(!addMoreScanner);
  };

  const toggleEditScanner = (scanner) => {
    if (!scanner) {
      setEditData(null);
      setIsEditScanner(!isEditScanner);
      return;
    } else {
      setEditData(scanner);
      setIsEditScanner(!isEditScanner);
    }
  };

  const handleDeleteScanner = async (id) => {
    const tostId = toast.loading("Deleting scanner...");
    try {
      const { response, error } = await httpServices.delete(
        `/scannersDetails/delete/${id}`
      );

      if (error) {
        throw error;
      }
      if (response.status === 200) {
        toast.update(tostId, {
          render: "Scanner deleted successfully",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });

        getEventScanner();
      }
    } catch (error) {
      toast.update(tostId, {
        render: "Error deleting scanner",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    }
  };

  return (
    <>
      {addMoreScanner && (
        <AddTicketScanner
          toggleAddMoreScanner={toggleAddMoreScanner}
          getEventScanner={getEventScanner}
        />
      )}
      {isEditScanner && (
        <AddTicketScanner
          editData={editData}
          toggleAddMoreScanner={toggleEditScanner}
          getEventScanner={getEventScanner}
        />
      )}
      <div className="flex justify-between items-center py-[16px]">
        <h1 className="gradient-text  font-medium text-lg">Ticket scanners</h1>
        <button
          class="relative inline-flex items-center justify-center p-0.5  overflow-hidden text-sm font-medium text-gray-900 rounded-[10px] bg-gradient-to-t from-[#2E3E8D] to-[#4DB1E1]"
          onClick={toggleAddMoreScanner}
        >
          <span class="relative px-[10px] py-[9px] bg-white rounded-[10px] flex items-center gap-[6px]">
            <svg
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 1.5V13.5"
                stroke="url(#paint0_linear_157_1826)"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 7.5H13"
                stroke="url(#paint1_linear_157_1826)"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_157_1826"
                  x1="7.325"
                  y1="13.5"
                  x2="7.325"
                  y2="1.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#2E3E8D" />
                  <stop offset="1" stop-color="#4DB1E1" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_157_1826"
                  x1="4.9"
                  y1="8.5"
                  x2="4.9"
                  y2="7.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#2E3E8D" />
                  <stop offset="1" stop-color="#4DB1E1" />
                </linearGradient>
              </defs>
            </svg>

            <span class="bg-clip-text text-transparent bg-gradient-to-t from-[#2E3E8D] text-sm to-[#4DB1E1]">
              Add more
            </span>
          </span>
        </button>
      </div>
      <div className="w-full bg-[#F5F6FA] !px-[10px] xs:!px-4 rounded-[10px] min-h-[728px]">
        <div className="overflow-x-auto">
          <table
            className="table-auto border-separate w-full"
            style={{ borderSpacing: "0 10px" }}
          >
            <thead className="table-text">
              <tr>
                <th className="pt-[20px] pr-5 whitespace-nowrap">
                  <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] sm:pl-[46px]">
                    Name
                  </div>
                </th>
                <th className="pt-[20px] pr-5 whitespace-nowrap">
                  <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] ">
                    Email
                  </div>
                </th>
                <th className="pt-[20px] pr-5 whitespace-nowrap">
                  <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] ">
                    Mobile Number
                  </div>
                </th>

                <th className="pt-[20px] pr-5 whitespace-nowrap">
                  <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] ">
                    Password
                  </div>
                </th>
                <th className="pt-[20px] pr-5 whitespace-nowrap">
                  <div className="font-normal text-xs text-[#06152B] text-left pl-[10px] ">
                    Action
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="text-sm divide-y divide-gray-100">
              {sannerList?.map((scanner) => (
                <tr key={scanner?.email} className="bg-white">
                  <td className="whitespace-nowrap pr-5 mt-[10px] pl-[15px] sm:pl-[46px] rounded-l-[10px]">
                    <div className="flex items-center py-[20px]">
                      <h5 className="table-text pb-0 text-xs sm:text-sm">
                        {scanner?.name}
                      </h5>
                    </div>
                  </td>
                  <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px]  ">
                    <div className="flex items-center py-[20px]">
                      <h5 className="table-text pb-0 text-sm ">
                        {scanner?.email}
                      </h5>
                    </div>
                  </td>
                  <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px] ">
                    <div className="flex items-center py-[20px]">
                      <h5 className="table-text pb-0 text-sm">
                        {scanner?.phoneNumber || "not-found"}
                      </h5>
                    </div>
                  </td>

                  <td className="whitespace-nowrap pr-5 mt-[10px] pl-[10px]  ">
                    <div className="flex items-center py-[20px]">
                      <h5 className="table-text pb-0 text-sm">
                        {scanner?.password}
                      </h5>
                    </div>
                  </td>
                  <td className="whitespace-nowrap pr-5 mt-[10px] rounded-r-[10px] pl-[10px]">
                    <div className=" py-[20px]">
                      <span
                        className="table-text underline text-dark-blue cursor-pointer"
                        onClick={() => toggleEditScanner(scanner)}
                      >
                        Edit
                      </span>
                      <span className="table-text text-[#ADADAD]"> / </span>
                      <span
                        className="table-text text-[#B80000] cursor-pointer"
                        onClick={() => handleDeleteScanner(scanner.id)}
                      >
                        Delete
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default SingleEventScanner;
